
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import store_dhis2 from "@/store/mods/consultations/dhis-diagnostics"
import $ from 'jquery'
import Api from '@/api/api.js'

export default {
    name: 'manage-dhis-2-diagnostic',
    components: {},
    props: {
        section_name: String,
        slug: String,
        consultation_id: Number,
        evolution_id: Number,
        user_id: Number,
        info_user: Object,
        patient: Object,
        group_id: Number,
        modal_toggler: Number,
        data_to_be_deleted: Object,
        selected_grp_diagnosis: Object,
        p_is_femme_enceinte: Number
    },
    data() {
        return {
            dhis2_diagnostics: [],
            icd11_query: '',
            icd11_results: [],
            icd11_timer: null,
            diag_loading: true,
            diag_is_empty: false,

            diagnostics_checked: [],
            is_new_case: {},
            one_is_empty: false,

            checked_is_empty: false,
            filter_diagnostic: '',
            filtered_diagnostics: [],
            
            is_femme_enceinte: "",
            can_show_list: true,
            choice_is_empty: false,

            save_loading: false,
            is_error: false,
            permission_is_denied: false,
            choice_msg_error: '',

            info_patient: {
                sexe: '',
                age: 0
            },
            is_edit: 0,
            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
        modal_toggler() {
            this.diagnostics_checked = []
            this.is_new_case = []
            this.is_femme_enceinte = this.p_is_femme_enceinte
            this.one_is_empty = false
            this.save_loading = false
            this.clearError()

            if (this.selected_grp_diagnosis.diagnostics.length > 0) {
                this.is_edit = 1
                this.autoFillAddedDiagnostics()
            } else {
                this.is_edit = 0
                // Remove disable attribute from all checkboxes
                this.filtered_diagnostics.forEach(diag => {
                    const checkbox = document.getElementById('dhisdiag' + diag.id);
                    if (checkbox) {
                        checkbox.disabled = false;
                    }
                });

                for (let i = 0; i < this.filtered_diagnostics.length; i++) {
                    console.log();
                    
                    this.is_new_case[i] = ""
                }
            }
        },

        is_new_case() {
            this.clearError()
        },

        is_femme_enceinte() {
            this.clearError()
        },

        diagnostics_checked() {
            this.checked_is_empty = false
        },

        filter_diagnostic() {
            this.filterDiag()
        }
    },

    computed: {

    },

    mounted() {
        this.getListDiagnosticDHIS2()
        this.setPatientInfo()
    },
    beforeDestroy() { if (this.icd11_timer) clearTimeout(this.icd11_timer) },

    methods: {
        searchIcd11() {
            if (this.icd11_timer) clearTimeout(this.icd11_timer)
            this.icd11_results = []
            const query = this.icd11_query.trim()
            if (query.length < 2) return
            this.icd11_timer = setTimeout(() => {
                Api().get('/icd11/search', { params: { q: query } }).then(response => {
                    if (this.icd11_query.trim() === query) this.icd11_results = response.data.data || []
                }).catch(() => { this.icd11_results = [] })
            }, 250)
        },
        setPatientInfo() {
            this.info_patient.sexe = this.patient.sexe_id === 1 ? 'M' : 'F';
            let age = this.patient.age
            // check if age contains "ans"
            if (age.includes("ans")) {
                // extract the number before "ans"
                age = parseInt(age.split("ans")[0].trim());
            } else {
                age = 0
            }

            this.info_patient.age = age
        },

        clearError() {
            this.choice_is_empty = false
            this.one_is_empty = false
            this.choice_msg_error = ''
            this.is_error = false
            this.permission_is_denied = false
            this.is_confirm = false
        },

        getListDiagnosticDHIS2() {
            this.diag_loading = true
            this.dhis2_diagnostics = []
            const data = {
                dataset_uid: ''
            }
            store_fiche.getListeDiagnosticDHIS2(data).then((response) => {
                this.dhis2_diagnostics = response

                if (response.length === 0) {
                    this.diag_is_empty = true
                } else {
                    this.diag_is_empty = false
                    this.filtered_diagnostics = response
                }
                this.diag_loading = false
            })
        },

        autoFillAddedDiagnostics() {
            if (this.selected_grp_diagnosis.diagnostics.length > 0) {
                this.filtered_diagnostics.forEach(diag => {
                    this.selected_grp_diagnosis.diagnostics.forEach(el => {
                        if (el.diagnostic_uid === diag.diagnostic_uid) {
                            // disable the diagnostic checkbox by id using  getElementById
                            const checkbox = document.getElementById('dhisdiag' + diag.id);
                            if (checkbox) {
                                checkbox.disabled = true;
                            }
                        }
                    });
                });
            }
            // this.is_femme_enceinte = this.selected_grp_diagnosis.is_femme_enceinte
        },

        async filterDiag() {
            this.filtered_diagnostics = [];

            if (this.filter_diagnostic == '') {
                this.filtered_diagnostics = this.dhis2_diagnostics
            } else {
                this.dhis2_diagnostics.forEach(diag => {
                    let cleaned_diag = this.removeAccents(diag.diagnostic)
                    let cleaned_filter = this.removeAccents(this.filter_diagnostic)

                    if (cleaned_diag.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_diagnostics.push(diag)
                    }
                });
            }

            await setTimeout(() => {
                this.autoFillAddedDiagnostics()
            }, 600);
        },

        saveDHISDiagnostic() {
            console.log("isfe: ",this.is_femme_enceinte);
            
            if (this.patient.sexe_id === 2  && this.is_femme_enceinte === "") {
                this.choice_is_empty = true
                this.choice_msg_error = "Veuillez indiquer si la patiente est enceinte ou non !"
                return
            } 

            if (this.diagnostics_checked.length === 0) {
                this.checked_is_empty = true
                return
            }

            this.one_is_empty = false
            const diagnostics = this.diagnostics_checked.map(uid => {
                const diag = this.filtered_diagnostics.find(d => d.diagnostic_uid === uid);

                if (!this.is_new_case[uid]) {
                    this.one_is_empty = true
                }
                return {
                    diagnostic_uid: uid,
                    diagnostic_name: diag?.diagnostic || '',
                    case_type: (this.is_new_case[uid])?parseInt(this.is_new_case[uid]):""
                };
            });

            if (this.one_is_empty) {
                this.choice_msg_error = "Veuillez indiquer s'il s'agit d'un nouveau cas ou non pour chaque disgnostic !"
                return;
            }

            this.save_loading = true

            const data = {
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                data_type: 'dhis2_diagnostic',
                group_id: this.group_id,
                diagnostics: diagnostics,
                is_femme_enceinte: this.is_femme_enceinte,
                user_id: this.user_id,
                user: this.info_user,
                info_patient: this.info_patient
            }
            console.log("Data to save DHIS2 Diagnostic:", data);

            store_dhis2.saveDHIS2Diagnostic(data).then((response) => {
                if (response.success) {
                    this.successToast('Ajout effectué avec succès')
                    this.$emit('emitRefreshDHIS2Diagnostic')
                    this.$refs.mdl_dhis2_diagnostic.click()

                    this.diagnostics_checked = []
                    this.is_new_case = ""
                    this.filter_diagnostic = ''
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response.code === 403) {
                        this.permission_is_denied = true
                    } else if (response.code === 401) {
                        this.choice_is_empty = true
                        this.choice_msg_error = response.message || 'Veuillez vérifier vos choix.'
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        deleteDHISDiagnostic(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }
            
            console.log(this.data_to_be_deleted);

            this.del_loading = true
            store_dhis2.deleteConsultationDHIS2Diagnostic(this.data_to_be_deleted).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit('emitRefreshDHIS2Diagnostic')
                    this.$refs.del_dhis_diagnosis.click()
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response.code === 403) {
                        this.permission_is_denied = true
                    }
                }
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },
    }
}
